// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__GG8T8","Heading":"style_Heading__1evNV"};